import styleParam from '../BookOnline/stylesParams';

export { customCssVars } from '../BookOnline/stylesParams';

export default styleParam;
